import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function WaiverPage() {
  const [agreed, setAgreed] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [waiverData, setWaiverData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const stored = sessionStorage.getItem('roboKidsWaiverSession');
    if (!stored) {
      alert("❌ Registration info missing. Please return to the form.");
      navigate('/robokids');
      return;
    }

    try {
      const parsed = JSON.parse(stored);
      setWaiverData(parsed);
    } catch (err) {
      console.error("Invalid waiver session data:", err);
      alert("There was a problem loading your registration.");
      navigate('/robokids');
    }
  }, [navigate]);

  const handleAgree = async () => {
    if (!waiverData?.email || !waiverData?.guardianName || !waiverData?.classType) {
      alert("❌ Missing required info. Please return to the form.");
      return;
    }

    const payload = {
      guardianName: waiverData.guardianName,
      childName: waiverData.childName,
      childAge: waiverData.childAge || '',
      email: waiverData.email,
      startDate: waiverData.startDate || waiverData.selectedDate || '',
      classType: waiverData.classType,
      addressLine1: waiverData.addressLine1 || waiverData?.address?.line1 || '',
      addressLine2: waiverData.addressLine2 || waiverData?.address?.line2 || '',
      city: waiverData.city || waiverData?.address?.city || '',
      state: waiverData.state || waiverData?.address?.state || '',
      zipCode: waiverData.zipCode || waiverData?.address?.zip || '',
      timestamp: waiverData.timestamp || Date.now()
    };

    console.log("📦 Sending payload to Lambda:", payload);

    try {
      setLoading(true);

      const res = await fetch("https://zwc2lun76ai5eqlfzvsv2vaqta0xgvks.lambda-url.us-east-1.on.aws/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        const error = await res.json();
        throw new Error(error.message || "Server error");
      }

      sessionStorage.removeItem('roboKidsWaiverSession');
      localStorage.removeItem('roboKidsRegistration');
      setSubmitted(true);
    } catch (err) {
      console.error("❌ Error sending email:", err);
      alert("There was a problem submitting the waiver. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', fontFamily: 'sans-serif' }}>
      <h1>📄 Robo Kids Waiver</h1>

      <iframe
        title="Robo Kids Waiver PDF"
        src="/waiver.pdf"
        width="100%"
        height="600px"
        style={{ border: '1px solid #ccc', marginBottom: '1rem' }}
      />

      <p>
        Please review the full waiver above. You can also{' '}
        <a href="/waiver.pdf" download style={{ color: '#007bff' }}>download the waiver here</a>.
      </p>

      {!submitted ? (
        <>
          <label style={{ display: 'block', marginTop: '1rem' }}>
            <input
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              style={{ marginRight: '0.5rem' }}
              disabled={loading}
            />
            I have read and agree to the terms of the waiver.
          </label>

          <button
            onClick={handleAgree}
            disabled={!agreed || loading}
            style={{
              marginTop: '1rem',
              padding: '0.75rem 1.5rem',
              backgroundColor: agreed ? '#28a745' : '#ccc',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: agreed && !loading ? 'pointer' : 'not-allowed',
              opacity: loading ? 0.6 : 1,
              fontSize: '1rem',
              fontWeight: 'bold'
            }}
          >
            {loading ? "Sending..." : "✅ I Agree & Complete Registration"}
          </button>
        </>
      ) : (
        <div style={{ marginTop: '2rem', color: 'green', fontWeight: 'bold', textAlign: 'center' }}>
          ✅ Waiver submitted successfully!<br />
          A confirmation email will arrive shortly. Welcome to Robo Kids!
          <br /><br />
          <a href="/" style={{ color: '#007bff', textDecoration: 'underline' }}>
            ← Return to Homepage
          </a>
        </div>
      )}
    </div>
  );
}
